import React, { ChangeEvent, FC } from 'react';
import { FormControl, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

type OrderOrInvoiceIdFreeTextFilterProps = {
    onOrderOrInvoiceIdChange: (orderOrInvoiceId: string) => void;
    value: string;
};
const OrderOrInvoiceIdFreeTextFilter: FC<OrderOrInvoiceIdFreeTextFilterProps> = ({
    onOrderOrInvoiceIdChange,
    value,
}: OrderOrInvoiceIdFreeTextFilterProps) => {
    const { t: translate } = useTranslation('orders');
    const handleOrderOrInvoiceIdChange = (event: ChangeEvent<HTMLInputElement>) => {
        onOrderOrInvoiceIdChange(event.target.value);
    };
    return (
        <FormControl fullWidth>
            <TextField
                id="freetext-filter"
                label={translate('orders:ORDER_ID')}
                value={value}
                onChange={handleOrderOrInvoiceIdChange}
            />
        </FormControl>
    );
};

export default OrderOrInvoiceIdFreeTextFilter;
